import React from "react";

interface TableLoaderProps {
  count?: number;
}

export const TableLoader: React.FC<TableLoaderProps> = ({ count = 10 }) => {
  return (
    <div>
      {[...Array(count)].map((_, idx) => (
        <div
          key={idx}
          className="w-full animate-pulse bg-gray-200 h-8 dark:bg-gray-700 mb-2"
        />
      ))}
    </div>
  );
};
